import {BaSeButton, BaSeHeading6, BaSeInputList, BaSeOptionPicker,} from "@base/react"
import {useCallback, useEffect, useMemo, useState} from "react"
import {useLocation, useNavigate} from "react-router-dom"
import {converterSnakeToCamelCase, eventTag, getCurrentCNPJ, uuid,} from "../../services/utils"
import ModalDefault from "../../components/modals/modal-default"
import {toast} from "react-toastify"
import ToastContent from "../../components/toastContent"
import PagePlanningsStructure, {TabsAndOrderBy,} from "../../components/page-plannings-structure"
import {useApp} from "../../hooks/use-app"
import moment from "moment/moment"
import Loading from "../../components/loading"
import EmptyPlannings from "../../components/empty-plannings"
import ListPlanning from "./components/listPlannings"
import Trash from "./components/trash"
import ApiPlannings from "../../services/planning"
import {optionsPeriod} from "../../mocks/consts"
import {useDebounced} from "../../hooks/use-debounce"
import "./index.scss"

const apiPlannings = ApiPlannings()

const event = {
  name: "planning",
  category: "planejamentos",
  action: "click",
}

const PAGE_SIZE = 8 //8
const DEFAULT_ORDER_BY = "sort_by_created_at=desc"
const INITIAL_LIST_STATE = {
  count: 0,
  results: [],
  loading: false,
}
const INITIAL_FILTERS = {
  searchList: [],
  period: null,
  usersShared: [],
  isFinished: null,
  orderBy: DEFAULT_ORDER_BY,
}
const ALL_USERS_SHARED_OPTION = {
  id: 0,
  label: "Todos",
}
const currentYear = new Date().getFullYear()

const Plannings = ({ account }) => {
  const navigate = useNavigate()
  const routerLocation = useLocation()

  const {
    companies,
    reachedTheLimitOfPlanning,
  } = useApp()

  const sharedPlanAccepted = routerLocation?.state?.sharedPlanAccepted
  const sharedPlanTitle = routerLocation?.state?.sharedPlanTitle || ""
  const ownLinkError = routerLocation?.state?.ownLinkError
  const ownLinkMessage = routerLocation?.state?.ownLinkMessage

  const currentCnpj = useMemo(() => {
    return getCurrentCNPJ(companies) || null
  }, [companies])

  const [showModal, setShowModal] = useState(false)
  const [showModalSharedPlan, setShowSharedPlan] = useState({
    status: false,
    titlePlan: null,
  })

  const [loading, setLoading] = useState(true)
  const [searchInput, setSearchInput] = useState("")
  const [filters, setFilters] = useState(INITIAL_FILTERS)

  const [listPlanning, setListPlanning] = useState(INITIAL_LIST_STATE)
  const [listTrash, setListTrash] = useState(INITIAL_LIST_STATE)

  const [updatePlanning, setUpdatePlanning] = useState(false)
  const [updateTrash, setUpdateTrash] = useState(false)
  const [openCardId, setOpenCardId] = useState(null)

  const [paramsPlanning, setParamsPlanning] = useState({
    cnpj: currentCnpj,
    page: 1,
    page_size: PAGE_SIZE,
  })
  const [paramsTrash, setParamsTrash] = useState({
    cnpj: currentCnpj,
    page: 1,
    page_size: PAGE_SIZE,
  })
  const [optionsShared, setOptionsShared] = useState([])
  const [usersSharedSelectedIds, setUsersSharedSelectedIds] = useState([
    ALL_USERS_SHARED_OPTION.id,
  ])
  const optionsSharedWithAll = useMemo(() => {
    return [ALL_USERS_SHARED_OPTION, ...optionsShared]
  }, [optionsShared])
  const searchParam = useMemo(() => {
    if (!filters.searchList.length) return null

    return filters.searchList
      .map((item) => item.label)
      .join(",")
  }, [filters.searchList])
  const periodParams = useMemo(() => {
    if (!filters.period?.monthAmt) {
      return {
        start_date: null,
        end_date: null,
      }
    }

    return {
      start_date: moment()
        .subtract(filters.period.monthAmt, "months")
        .format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    }
  }, [filters.period])
  const usersSharedParam = useMemo(() => {
    if (!filters.usersShared.length) return null

    const ids = filters.usersShared
      .filter((item) => item.id !== 0)
      .map((item) => item.id)

    return ids.length ? ids.join(",") : null
  }, [filters.usersShared])

  const resetPlanningPage = () => {
    setParamsPlanning((prev) => ({
      ...prev,
      page: 1,
    }))
  }
  const resetTrashPage = () => {
    setParamsTrash((prev) => ({
      ...prev,
      page: 1,
    }))
  }
  const resetAllPages = () => {
    resetPlanningPage()
    resetTrashPage()
  }

  const setPlanningLoading = (value = true) => {
    setListPlanning((prev) => ({
      ...prev,
      loading: value,
    }))
  }
  const setTrashLoading = (value = true) => {
    setListTrash((prev) => ({
      ...prev,
      loading: value,
    }))
  }
  const setAllLoading = (value = true) => {
    setPlanningLoading(value)
    setTrashLoading(value)
  }

  const forceUpdateListPlanning = () => {
    setUpdatePlanning(true)

    setTimeout(() => {
      setUpdatePlanning(false)
    }, 1000)
  }
  const forceUpdateListTrash = () => {
    setUpdateTrash(true)

    setTimeout(() => {
      setUpdateTrash(false)
    }, 1500)
  }

  const getUsersShared = async () => {
    try {
      const { data } = await apiPlannings.usersSharedList({
        cnpj: currentCnpj,
      })
      const newData = data.map(item => {
        const id = item?.cpf.replace(/\D/g, "")
        return {
          id: id,
          label: item?.name,
          cpf: item?.cpf,
        }
      })
      setOptionsShared(newData)
    } catch (error) {
      console.warn(error)
    } finally {

    }
  }

  const handleCreatePlanning = () => {
    if (reachedTheLimitOfPlanning) {
      setShowModal(true)
      return
    }

    navigate("/planejamento")
  }

  const toggleSearchTags = (item) => {
    let nextTags = [...filters.searchList]

    if (typeof item !== "string") {
      nextTags = nextTags.filter((tag) => tag.id !== item.id)
    } else {
      const value = item.trim()

      if (!value) return

      nextTags.push({
        id: uuid(),
        label: value,
      })

      eventTag(
        event.name,
        event.category,
        "submit",
        `Filtro por pesquisa: ${value}`
      )
    }

    setSearchInput("")

    setFilters((prev) => ({
      ...prev,
      searchList: nextTags,
    }))

    resetAllPages()
    setAllLoading(true)
  }

  const handlePeriodChange = (selected) => {
    const period = selected?.[0] || null

    setFilters((prev) => ({
      ...prev,
      period,
    }))

    resetAllPages()
    setAllLoading(true)

    eventTag(
      event.name,
      event.category,
      "submit",
      `Filtro por período: ${period?.label || "Todos"}`
    )
  }

  const [debouncedUsersShared] = useDebounced((selectedUsers) => {
    eventTag(
      event.name,
      event.category,
      "submit",
      `Filtro por compartilhamento`
    )
    setFilters((prev) => ({
      ...prev,
      usersShared: selectedUsers || [],
    }))

    resetPlanningPage()
    setPlanningLoading(true)
  }, 500)
  const handleUsersSharedChange = (selectedUsers) => {
    const selectedItems = selectedUsers || []
    const hasAllOption = selectedItems.some(
      (item) => item.id === ALL_USERS_SHARED_OPTION.id
    )
    const hadAllOptionSelected = usersSharedSelectedIds.includes(
      ALL_USERS_SHARED_OPTION.id
    )
    const normalizedUsers =
      hasAllOption && !hadAllOptionSelected
        ? []
        : selectedItems.filter((item) => item.id !== ALL_USERS_SHARED_OPTION.id)

    setUsersSharedSelectedIds(
      normalizedUsers.length
        ? normalizedUsers.map((item) => item.id)
        : [ALL_USERS_SHARED_OPTION.id]
    )
    debouncedUsersShared(normalizedUsers)
  }

  const handleOrderByChange = useCallback((filter) => {
    const statusMap = {
      all: null,
      progress: false,
      completed: true,
    }
    const statusMapLabel = {
      all: "Todos",
      progress: "Em andamento",
      completed: "Concluídos",
    }

    setFilters((prev) => {
      const nextIsFinished = statusMap[filter.tab]
      const nextOrderBy = filter.orderBy || DEFAULT_ORDER_BY

      eventTag(
        event.name,
        event.category,
        "submit",
        `Filtro por: ${statusMapLabel[filter.tab]}`
      )

      if (
        prev.isFinished === nextIsFinished &&
        prev.orderBy === nextOrderBy
      ) {
        return prev
      }

      return {
        ...prev,
        isFinished: nextIsFinished,
        orderBy: nextOrderBy,
      }
    })

    setParamsPlanning((prev) => {
      if (prev.page === 1) return prev

      return {
        ...prev,
        page: 1,
      }
    })

    setPlanningLoading(true)
  }, [])

  const loadMore = (type = "planning") => {
    eventTag(
      "click-button",
      event.category,
      event.action,
      `Carregar mais${type === "planning" ? " planejamentos" : ""}`
    )

    if (type === "planning") {
      if (listPlanning.loading) return

      setPlanningLoading(true)
      setParamsPlanning((prev) => ({
        ...prev,
        page: prev.page + 1,
      }))

      return
    }

    if (type === "trash") {
      if (listTrash.loading) return

      setTrashLoading(true)
      setParamsTrash((prev) => ({
        ...prev,
        page: prev.page + 1,
      }))
    }
  }

  const handleRemovedUserFromPlanning = (planningId, userId) => {
    setListPlanning((prevList) => ({
      ...prevList,
      results: prevList?.results.map((planning) =>
        planning.id === planningId
          ? {
            ...planning,
            invites: planning.invites.filter(
              (invite) => invite.id !== userId
            ),
          }
          : planning
      ),
    }))
  }

  const fnCallbacksCard = ({ type, status }) => {
    if (type === "delete" || type === "restore") {
      if (status === "success") {
        resetPlanningPage()

        setParamsTrash({
          cnpj: currentCnpj,
          page: 1,
          page_size: PAGE_SIZE,
        })
      }

      if (status === "finalized") {
        setLoading(false)
        forceUpdateListPlanning()
        forceUpdateListTrash()
      }

      return
    }
    if (type === "duplicate" && status === "success") {
      resetPlanningPage()
      return
    }
    if (type === "monitor" && status === "finalized") {
      forceUpdateListPlanning()
    }
  }

  const handleSearchInputEnter = (event) => {
    event.preventDefault()
    event.currentTarget
      ?.closest(".BaSe--input-list-container")
      ?.querySelector("button")
      ?.click()
  }

  const layoutFilters = (
    <>
      <BaSeInputList
        value={searchInput}
        onChange={setSearchInput}
        placeholder="Pesquise por nome do planejamento"
        isDisabled={listPlanning.loading || listTrash.loading}
        buttonAction={toggleSearchTags}
        typeButton="base-icon"
        nameButton="search"
        valueButton=""
        onSpecificKeyDown={[
          {
            listenerKey: "Enter",
            callback: handleSearchInputEnter,
          },
        ]}
        listItems={{
          direction: "row",
          columnNum: 1,
          gap: "8px",
          valuesList: filters.searchList,
          listActions: [
            {
              size: "small",
              sizeIcon: "small",
              ActionisDisabled: false,
              nameIcon: "close",
              color: "#005EB8",
              listAction: toggleSearchTags,
            },
          ],
        }}
      />
      <div className="wrapper-select with-icon calendar">
        <BaSeOptionPicker
          label="Período"
          values={optionsPeriod}
          emptyValueLabel="Selecione"
          enableSelectAll={false}
          maxOptionsSelected={1}
          withFilterText={false}
          initialSelectedValuesId={[0]}
          onChange={handlePeriodChange}
          isDisabled={listPlanning.loading || listTrash.loading}
        />
      </div>
      <div className="wrapper-select with-icon users">
        <BaSeOptionPicker
          label="Compartilhamento"
          values={optionsSharedWithAll}
          emptyValueLabel="Todos"
          enableSelectAll={false}
          withFilterText={false}
          initialSelectedValuesId={usersSharedSelectedIds}
          onChange={handleUsersSharedChange}
          isDisabled={listPlanning.loading || listTrash.loading}
        />
      </div>
    </>
  )
  const layoutContent = (
    <>
      <TabsAndOrderBy
        tabs={[
          {
            label: "Todos",
            count: listPlanning?.count || 0,
            action: "all",
          },
          {
            label: "Em andamento",
            action: "progress",
          },
          {
            label: "Concluídos",
            action: "completed",
          },
        ]}
        onFilter={handleOrderByChange}
        isDisabled={listPlanning.loading || listTrash.loading}
        event={event}
      />

      <div className="list-planning">
        {loading ? (
          <div className="wrapper-loading-small">
            <Loading small />
          </div>
        ) : !listPlanning.count && !listTrash.count ? (
          <EmptyPlannings subtitle="Crie seu primeiro planejamento e organize as finanças do seu negócio.">
            <BaSeButton
              color="#005EB8"
              value="Criar novo planejamento"
              onClick={() => {
                handleCreatePlanning()
                eventTag(
                  event.name,
                  event.category,
                  event.action,
                  "Criar novo planejamento"
                )
              }}
            />
          </EmptyPlannings>
        ) : (
          <>
            <div className="list-planning">
              <ListPlanning
                event={event}
                account={account}
                listPlanning={listPlanning}
                updatePlanning={updatePlanning}
                openCardId={openCardId}
                setOpenCardId={setOpenCardId}
                handleRemovedUserFromPlanning={handleRemovedUserFromPlanning}
                loadMore={() => loadMore("planning")}
                callbackCardFinalized={(e) => fnCallbacksCard(e)}
              />
            </div>

            <div className="trash-planning">
              <Trash
                event={event}
                listTrash={listTrash}
                updateTrash={updateTrash}
                loadMore={() => loadMore("trash")}
                callbackCardFinalized={(e) => fnCallbacksCard(e)}
              />
            </div>
          </>
        )}
      </div>
    </>
  )

  useEffect(() => {
    let isMounted = true

    const fetchPlanning = async () => {
      const isLoadMore = paramsPlanning.page > 1

      setPlanningLoading(true)

      const apiParams = {
        ...paramsPlanning,
        ...periodParams,
        in_trashcan: false,
      }

      if (searchParam) {
        apiParams.plan_title = searchParam
      }
      if (filters.isFinished !== null) {
        apiParams.is_finished = filters.isFinished
      }
      if (usersSharedParam) {
        apiParams.users_shared = usersSharedParam
      }
      if (filters.orderBy) {
        const [key, value] = filters.orderBy.split("=")
        apiParams[key] = value
      }

      try {
        const { data } = await apiPlannings.planningsList(apiParams)

        if (!isMounted) return

        const results = data.results.map((item) =>
          converterSnakeToCamelCase(item)
        )
        setListPlanning((prev) => ({
          ...data,
          loading: false,
          results: isLoadMore
            ? [...(prev.results || []), ...results]
            : results,
        }))
      } catch (err) {
        console.warn(err)

        if (isMounted) {
          setPlanningLoading(false)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchPlanning()

    return () => {
      isMounted = false
    }
  }, [
    paramsPlanning,
    periodParams,
    searchParam,
    filters.isFinished,
    filters.orderBy,
    usersSharedParam,
  ])
  useEffect(() => {
    let isMounted = true

    const fetchTrash = async () => {
      const isLoadMore = paramsTrash.page > 1

      setTrashLoading(true)

      const apiParams = {
        ...paramsTrash,
        ...periodParams,
        in_trashcan: true,
      }

      if (searchParam) {
        apiParams.plan_title = searchParam
      }

      try {
        const { data } = await apiPlannings.planningsList(apiParams)

        if (!isMounted) return

        const results = data.results.map((item) =>
          converterSnakeToCamelCase(item)
        )

        setListTrash((prev) => ({
          ...data,
          loading: false,
          results: isLoadMore
            ? [...(prev.results || []), ...results]
            : results,
        }))
      } catch (err) {
        console.warn(err)

        if (isMounted) {
          setTrashLoading(false)
        }
      }
    }

    fetchTrash()

    return () => {
      isMounted = false
    }
  }, [
    paramsTrash,
    periodParams,
    searchParam,
  ])
  useEffect(() => {
    setLoading(true)
    setSearchInput("")
    setFilters(INITIAL_FILTERS)
    setUsersSharedSelectedIds([ALL_USERS_SHARED_OPTION.id])
    setListPlanning(INITIAL_LIST_STATE)
    setListTrash(INITIAL_LIST_STATE)

    setParamsPlanning({
      cnpj: currentCnpj,
      page: 1,
      page_size: PAGE_SIZE,
    })
    setParamsTrash({
      cnpj: currentCnpj,
      page: 1,
      page_size: PAGE_SIZE,
    })

    getUsersShared()

    // eslint-disable-next-line
  }, [currentCnpj])
  useEffect(() => {
    if (sharedPlanAccepted === true) {
      setShowSharedPlan({
        status: true,
        titlePlan: sharedPlanTitle,
      })

      eventTag(
        event.name,
        "atendimento",
        "submit",
        `Solicitação de acesso: ${sharedPlanTitle}`
      )

      navigate(routerLocation.pathname, {
        replace: true,
        state: {},
      })
    } else if (ownLinkError) {
      toast.error(
        <ToastContent
          description={ownLinkMessage}
          title="Solicitação inválida."
        />
      )

      eventTag(
        event.name,
        "atendimento",
        "submit",
        `Solicitação inválida: ${sharedPlanTitle}`
      )

      navigate(routerLocation.pathname, {
        replace: true,
        state: {},
      })
    } else if (sharedPlanAccepted === false) {
      toast.error(
        <ToastContent
          description={`O planejador recusou seu pedido de acesso ao ${sharedPlanTitle}.`}
          title="Solicitação recusada."
        />
      )

      eventTag(
        event.name,
        "atendimento",
        "submit",
        `Solicitação recusada: ${sharedPlanTitle}`
      )

      navigate(routerLocation.pathname, {
        replace: true,
        state: {},
      })
    }
  }, [
    sharedPlanAccepted,
    sharedPlanTitle,
    ownLinkError,
    ownLinkMessage,
    navigate,
    routerLocation.pathname,
  ])

  return (
    <div className="plannings">
      <ModalDefault
        show={showModal}
        callBackClose={() => setShowModal(false)}
        square
        title="Limite Máximo de Planejamentos"
      >
        <div className="notes-modal">
          <BaSeHeading6>
            Você atingiu o limite máximo de <strong>120 planejamentos</strong>{" "}
            para o ano de {currentYear}.
          </BaSeHeading6>
          <br />
          <BaSeHeading6>
            Para adicionar novos planejamentos, por favor, exclua um
            planejamento já existente.
          </BaSeHeading6>
          <br />
          <BaSeButton value="Fechar" onClick={() => setShowModal(false)} />
        </div>
      </ModalDefault>

      <ModalDefault
        show={showModalSharedPlan?.status}
        callBackClose={() =>
          setShowSharedPlan({
            status: false,
            titlePlan: null,
          })
        }
        square
        title="Solicitação de acesso em análise"
        classCustom="dialog-alert"
      >
        <p className="dialog-alert__description">
          Você solicitou acesso ao{" "}
          <strong>{showModalSharedPlan?.titlePlan}</strong>.
          <br />
          Aguarde a aprovação do planejador.
        </p>

        <div className="dialog-alert__buttons">
          <BaSeButton
            value="Fechar"
            buttonType="button"
            color="#2E5DE6"
            size="medium"
            width="auto"
            onClick={() =>
              setShowSharedPlan({
                status: false,
                titlePlan: null,
              })
            }
          />
        </div>
      </ModalDefault>

      <div className="container">
        <PagePlanningsStructure
          title="Planejamentos"
          filters={layoutFilters}
          button={
            <BaSeButton
              color="#005EB8"
              value="Novo planejamento"
              onClick={() => {
                handleCreatePlanning()
                eventTag(
                  event.name,
                  event.category,
                  event.action,
                  "Novo planejamento"
                )
              }}
            />
          }
        >
          {layoutContent}
        </PagePlanningsStructure>
      </div>
    </div>
  )
}

export default Plannings
